import { render, staticRenderFns } from "./AuditTrailTable.vue?vue&type=template&id=2e9dc1f2&scoped=true&"
import script from "./AuditTrailTable.vue?vue&type=script&lang=ts&"
export * from "./AuditTrailTable.vue?vue&type=script&lang=ts&"
import style0 from "./AuditTrailTable.vue?vue&type=style&index=0&id=2e9dc1f2&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9dc1f2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardTitle,VCol,VIcon,VRow,VSpacer,VSwitch,VTextField})
